module.exports = __webpack_public_path__ + "img/payment-method-pix.5e6f6a9d.svg";